import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'
import {
  Order,
  OrderPart,
} from '../../../../../../../../src/api/cart/interfaces'
import Header from './header'
import { ISeller } from '../../../../../../../../src/services/MultiSellerServicesProvider'
import Parts from './parts'
import LocationInfo from './LocationInfo'

interface Props {
  order: Order
  coverageKey: string
  noteToStore: string
  poNumber: string
  sellersData: ISeller[]
  showYourCost: boolean
}

const OrderItem = (props: Props): ReactElement => {
  const {
    order,
    coverageKey,
    poNumber,
    noteToStore,
    sellersData,
    showYourCost,
  } = props
  const isMyPlaceOrder = coverageKey === ''

  const groupedParts = groupParts(order.parts)
  const groups = Object.entries(groupedParts)

  return (
    <Wrapper>
      <Header
        order={order}
        coverageKey={coverageKey}
        sellersData={sellersData}
        poNumber={poNumber}
        noteToStore={noteToStore}
        isMyPlaceOrder={isMyPlaceOrder}
      />

      {groups?.map(([locationName, parts]) => (
        <Fragment key={`${order.orderNumber}_${locationName}`}>
          <LocationInfo
            locationName={locationName}
            order={order}
            isMyPlaceOrder={isMyPlaceOrder}
          />
          <Parts parts={parts} showYourCost={showYourCost} />
        </Fragment>
      ))}
    </Wrapper>
  )
}

const groupParts = (array: OrderPart[]): Record<string, OrderPart[]> => {
  return array.reduce(
    (acc, part) => {
      const key = part.snCalled ?? ''

      if (!acc[key]) acc[key] = []

      acc[key].push(part)
      return acc
    },
    {} as Record<string, OrderPart[]>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

export default OrderItem
